module.exports = "/assets/d094e2c445ceb992268834e3f1071a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ID.png
// module id = 1470
// module chunks = 0